import { render } from "./SmallIcon.vue?vue&type=template&id=416e1067"
import script from "./SmallIcon.vue?vue&type=script&lang=js"
export * from "./SmallIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__